<template>
    <div v-if="policyDetail.main_class == '2' && !policyDetail.isEv">
        <div class="mt-2 p-4 bg-white rounded-lg">
            <div class="pb-2.5">
                <div class="text-16 font-medium text-a-black-555555 leading-22px">ประเภทการจัดซ่อม</div>
                <div class="pt-2 text-12 text-a-black-484848 leading-4.5"
                    v-for="rider in policyDetail.coverage.riders" :key="rider.value">
                    <div class="flex justify-between">
                        <div>{{ rider.label }}</div>
                        <div>{{ rider.detail }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="policyDetail.isEv">
        <div class="mt-2 p-4 bg-white rounded-lg">
            <div class="pb-2.5">
                <div class="text-16 font-medium text-a-black-555555 leading-22px">{{ policyDetail.drivers.header }}</div>
                <div class="pt-2 text-12 text-a-black-484848 leading-4.5">
                    <div class="flex-col gap-2" v-for="driver in policyDetail.drivers.details" :key="driver">
                        <div class="flex justify-between">
                            <div>{{ driver.label }}</div>
                            <div>{{ driver.detail }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TypeRepair',
    props: {
        policyDetail: Object
    },
}
</script>

